import styled from '@benzinga/themetron';

const SkeletonWrapper = styled.div`
  border-bottom: solid 1px #ddd;
  .ant-skeleton-content {
    padding: 12px !important;
    .ant-skeleton-title {
      height: 14px !important;
      margin: 0 !important;
      margin-bottom: 4px !important;
    }
    .ant-skeleton-paragraph {
      margin: 0 !important;
      li {
        height: 10px !important;
        height: 14px !important;
      }
    }
  }
  .news-skeleton {
    .ant-skeleton-content {
      padding: 12px 0 !important;
      .ant-skeleton-paragraph {
        margin: 0 !important;
        li {
          height: 16px !important;
        }
      }
    }
  }
`;

export const SkeletonQuoteCell = () => {
  return (
    <SkeletonWrapper>
      {/* <Skeleton active className="quote-skeleton" paragraph={{ rows: 1, width: 120 }} title={{ width: 50 }} /> */}
    </SkeletonWrapper>
  );
};

export const SkeletonNewsCell = () => {
  return (
    <SkeletonWrapper>
      {/* <Skeleton active className="news-skeleton" paragraph={{ rows: 2 }} title={false} /> */}
    </SkeletonWrapper>
  );
};

export default SkeletonQuoteCell;
